// Remove below imports/calls as appropriate


//* Popper is required for dropdowns, popovers and tooltips.
import '@popperjs/core'



import Alert from 'bootstrap/js/dist/alert'

var alertList = document.querySelectorAll('.alert')
alertList.forEach(function (alert) {
  new Alert(alert)
})


import Button from 'bootstrap/js/dist/button'

import Carousel from 'bootstrap/js/dist/carousel'

import Collapse from 'bootstrap/js/dist/collapse'

import Dropdown from 'bootstrap/js/dist/dropdown'

import Modal from 'bootstrap/js/dist/modal'

import OffCanvas from 'bootstrap/js/dist/offcanvas'


import Popover from 'bootstrap/js/dist/popover'

var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new Popover(popoverTriggerEl)
})


import ScrollSpy from 'bootstrap/js/dist/scrollspy'

import Tab from 'bootstrap/js/dist/tab'


import Toast from 'bootstrap/js/dist/toast'

var toastElList = [].slice.call(document.querySelectorAll('.toast'))
var toastList = toastElList.map(function (toastEl) {
  return new Toast(toastEl, 'delay')
})
toastList.forEach(toast => toast.show());


import Tooltip from 'bootstrap/js/dist/tooltip'

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl) 
})


